import { MutationHookOptions, useMutation } from '@apollo/client';

import { SaveUserConfiguration, SaveUserConfigurationVariables } 
  from '@/graphql/contracts/_generated_/saveUserConfiguration.mutation';
import SaveUserConfigurationQuery from '@/graphql/contracts/saveUserConfiguration.mutation.gql';
import { apolloClientContracts } from '@/apollo/clients/contracts.apollo';

const defaultOptions = { client: apolloClientContracts } as const;

export function useSaveUserConfiguration(
  baseOptions?: MutationHookOptions<SaveUserConfiguration, SaveUserConfigurationVariables>,
) {
  const options = { ...defaultOptions, ...baseOptions, context: { skipLoadingAnimation: true } };
  return useMutation<SaveUserConfiguration, SaveUserConfigurationVariables>(SaveUserConfigurationQuery, options);
}